import { apis, getTokenFromCookies } from "../service";
import { AxiosPromise, AxiosRequestConfig } from "axios";

const BASE_URL = "https://xxl6-bbr3-kxzs.m2.xano.io/api";
export const GROUPS = "https://xxl6-bbr3-kxzs.m2.xano.io/api:Gd8PAVtY";
export const SITE_URL = "https://xxl6-bbr3-kxzs.m2.xano.io/api";
const staff_order = `${BASE_URL}:M4Re3bq8/orders`;
const staff_deal = `${BASE_URL}:6JkkZBcl/deals`;
export const GetGroups = "https://xxl6-bbr3-kxzs.m2.xano.io/api:Gd8PAVtY/";
export const GetBranches = "https://xxl6-bbr3-kxzs.m2.xano.io/api:yyd3i3Ww";
const get_notification = `${BASE_URL}:nmGV7hFP/notifications`;
const edit_notification =
  "https://xxl6-bbr3-kxzs.m2.xano.io/api:nmGV7hFP/editNotification";
const fetch_swift_code = `https://api.api-ninjas.com/v1/swiftcode?swift=`;
const get_access_groups = `${BASE_URL}:Gd8PAVtY/group_to_assign`;

const API_URLS = {
  POST_STAFF_LOGIN: `${BASE_URL}:uw_L93nW/partner/v2-login`,
  FORGOT_PASSWORD: `${BASE_URL}:uw_L93nW/forgot-password`,
  GET_GROUPS: `${GROUPS}/groups`,
  POST_RESET_PASSWORD: `${BASE_URL}:uw_L93nW/auth/reset-password`,
  GROUPS: `${BASE_URL}Gd8PAVtY/groups`,
  STAFF_STAFF: `${BASE_URL}:gfz8um1p/staff`,
  STAFF_STAFF_POST: `${BASE_URL}:uw_L93nW`,
  STAFF_CHANNEL: `${BASE_URL}:MhhkaM6y/channels`,
  STAFF_CUSTOMER: `${BASE_URL}:NcXLAC78/customers`,
  STAFF_AUTH: `${BASE_URL}:uw_L93nW`,
  COMPANY_LEAD: `https://xxl6-bbr3-kxzs.m2.xano.io/api:FiAQK2sE:UAT/getCorporateLeads_v3`,
  SINGLE_COMPANY_LEAD: `${BASE_URL}:AtzopIo1/getSingleCompany`,
  PRIMARY_CONTACT: `${BASE_URL}:AtzopIo1/makePrimary_corporate`,
  EDIT_COMPANY_DETAIL: `${BASE_URL}:AtzopIo1/editCompanyDetail`,
} as const;

const GROUPS_API_URLS = {
  GET_GROUPS: `${GetGroups}/branch_access`,
};

// get channel table
export type GetAccessRoleRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  staff_id: number;
}>;

export const getAccessRoleGroup = (
  payload: AxiosRequestConfig<GetAccessRoleRequestType>,
): AxiosPromise =>
  apis.get(get_access_groups, {
    ...payload,
    params: {
      ...payload.data,
    },
  });

// Login API
export type PostStaffLoginRequestType = {
  data: {
    email: string;
    password: string;
  };
};

export type PostStaffLoginResponseType = Partial<{
  authToken?: {
    auth_token: string;
    channel_id?: number | undefined;
    level?: string | undefined;
    staff_id?: number | undefined;
  };
}>;

export const postStaffLogin = (payload: AxiosRequestConfig): AxiosPromise =>
  apis.post(API_URLS.POST_STAFF_LOGIN, payload);

// Forgot Password API

export type ForgotPasswordRequestType = {
  mail: string;
};

export type ForgotPasswordResponseType = Partial<{}>;

export const forgotPassword = (payload: AxiosRequestConfig): AxiosPromise =>
  apis.post(API_URLS.FORGOT_PASSWORD, payload);

// export const GetGroups = (payload: AxiosRequestConfig): AxiosPromise => apis.get(API_URLS.GET_GROUPS, payload);

export type GetListRequestParams = Partial<{
  q: string;
  page: number;
  per_page: number;
  type: string;
  status: string;
  role: string;
  kyc_status: string;
  city: string;
  order_by: string;
}>;
export type GetListResponse = {
  curPage: number;
  items: any;
  pageTotal: number;
  itemsTotal: number;
};

export const GetList = (
  url: string,
  payload: GetListRequestParams,
): AxiosPromise =>
  // apis.get(`${url}?q=${payload.q}&page=${payload.page}&per_page=${payload.per_page}`, { headers: { Authorization: getTokenFromCookies() } });
  apis.get(
    `${url}?q=${payload.q}&page=${payload.page}&per_page=${payload.per_page}&type=${payload.type}&status=${payload.status}&role=${payload.role}&kyc_status=${payload.kyc_status}&city=${payload.city}&order_by=desc`,
    {
      headers: {
        Authorization: getTokenFromCookies(),
      },
    },
  );

export const GetStaff = (payload: GetListRequestParams): AxiosPromise =>
  GetList(API_URLS.STAFF_STAFF, payload);
export const GetChannel = (payload: GetListRequestParams): AxiosPromise =>
  GetList(API_URLS.STAFF_CHANNEL, payload);
// export const GetCustomer = (payload: GetListRequestParams): AxiosPromise => GetList(API_URLS.STAFF_CUSTOMER, payload);
export type GetCustomerRequesrType = Partial<{
  headers: {
    Authorization: string;
  };
  params: {
    q: string;
    page: number;
    per_page: number;
    kyc_status: string;
    city: string;
    status: string;
  };
}>;
export type GetCustomerResponseType = {};

export const GetCustomer = (
  payload: AxiosRequestConfig<GetCustomerRequesrType>,
): AxiosPromise => apis.get(API_URLS.STAFF_CUSTOMER, payload);

// get channel table
export type GetChannelRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  params: {
    q: string;
    page: number;
    per_page: number;
    primary_location: string;
    type: string;
    status: string;
    order_by: string;
  };
}>;
export type GetChannelResponseType = {};

export const getChannel = (
  payload: AxiosRequestConfig<GetChannelRequestType>,
): AxiosPromise =>
  apis.get(API_URLS.STAFF_CHANNEL, {
    ...payload,
    headers: {
      Authorization: getTokenFromCookies(),
    },
  });

// get company Detail table
export type GetCompanyRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  params: {
    category: string;
    q: string;
     paging: {
    page: number;
    per_page: number;
  };
  };
}>;
export type GetCompanyResponseType = {};

export const getCompanyLeads = (
  payload: AxiosRequestConfig<GetCompanyRequestType>,
): AxiosPromise => apis.get(API_URLS.COMPANY_LEAD, payload);

// get single company Detail table
export type GetSingleCompanyRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  params: {
    coorporate_company_id: number;
  };
}>;
export type GetSingleCompanyResponseType = {};

export const getSingleCompanyLeads = (
  payload: AxiosRequestConfig<GetSingleCompanyRequestType>,
): AxiosPromise => apis.get(API_URLS.SINGLE_COMPANY_LEAD, payload);

export const postCustomer = (payload: AxiosRequestConfig): AxiosPromise =>
  apis.post(API_URLS.STAFF_CUSTOMER, payload);

// Reset Password API(First Time Login)
export type PostResetPasswordRequestType = {
  email: string;
  password: string;
  new_password: string | undefined;
};

export const postResetPassword = (
  payload: AxiosRequestConfig<PostResetPasswordRequestType>,
) => apis.post(API_URLS.POST_RESET_PASSWORD, payload);

// rest password using link
export type PostResetPasswordLinkRequestType = {
  token: string;
  new_password: string;
};

export type PostResetPasswordLinkResponseType = Partial<{}>;
export const postResetPasswordLink = (
  payload: AxiosRequestConfig<PostResetPasswordLinkRequestType>,
) => {
  const url = `${API_URLS.STAFF_AUTH}/owner/forget-verify`;
  return apis.post(url, payload);
};

// Get Groups API
export type GetGroupsRequest = Partial<{
  Authorization: string;
}>;
export type GetGroupsResponse = Partial<{
  id: string;
  created_at: string;
  channel_id: string;
  name: string;
  description: string;
}>;

export const postStaff = (payload: AxiosRequestConfig): AxiosPromise =>
  apis.post(API_URLS.STAFF_STAFF_POST, {
    ...payload,
    headers: {
      Authorization: getTokenFromCookies(),
    },
  });

// get order
export type GetOrderRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  page: number;
  per_page: number;
  service_partner_id: string;
  status: string;
  payment_status: string;
}>;
export type GetOrderResponseType = Partial<{}>;

export const getOrder = (
  payload: AxiosRequestConfig<GetOrderRequestType>,
): AxiosPromise => apis.get(staff_order, payload);

// get deal
export type GetDealRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  page: number;
  per_page: number;
  service_partner_id: string;
  status: string;
  utilization_status: string;
  payment_status: string;
}>;
export type GetDealResponseType = Partial<{}>;

export const getDeal = (
  payload: AxiosRequestConfig<GetOrderRequestType>,
): AxiosPromise => apis.get(staff_deal, payload);

// get notification

export type GetNotificationRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  staff_id: string;
}>;

export type GetNotificationResponseType = Partial<{}>;

export const getNotification = (
  payload: AxiosRequestConfig<GetNotificationRequestType>,
): AxiosPromise => apis.get(get_notification, payload);

export type PatchEditNotificationRequest = Partial<{
  headers: {
    Authorization: string;
  };
  notification_id: string;
  read: boolean;
}>;

export type PatchEditNotificationResponse = Partial<{}>;

export const PatchEditNotification = (
  payload: AxiosRequestConfig<GetNotificationRequestType>,
): AxiosPromise => apis.patch(edit_notification, payload);

export type MakePrimaryCompanyRequest = Partial<{
  headers: {
    Authorization: string;
  };
  contacts_id: string;
}>;

export type MakePrimaryCompanyResponse = Partial<{}>;

export const MakePrimaryCompany = (
  payload: AxiosRequestConfig<MakePrimaryCompanyRequest>,
): AxiosPromise => apis.patch(API_URLS.PRIMARY_CONTACT, payload);

export type EditCompanyRequest = Partial<{
  headers: {
    Authorization: string;
  };

  coorporate_company_id: number;
  staff_id: number;
  reminder_time: number;
  reminder_note: string;
  removeReminder: boolean;
  lead_status: string;
  note: string;
  branch:string
}>;

export type EditCompanyResponse = Partial<{}>;

export const EditCompany = (
  payload: AxiosRequestConfig<EditCompanyRequest>,
): AxiosPromise => apis.patch(API_URLS.EDIT_COMPANY_DETAIL, payload);

// get groups

export type GetGroupsRequestType = Partial<{
  headers: {
    Authorization: string;
  };
  params: {
    q: string;
    page: number;
    per_page: number;
    branch_id: string;
  };
}>;

export type GetGroupsResponseType = Partial<{}>;

export const getGroups = (
  payload: AxiosRequestConfig<GetGroupsRequestType>,
): AxiosPromise => apis.get(GROUPS_API_URLS.GET_GROUPS, payload);

// get swift code

export type GetSwiftCodeRequestType = Partial<{
  headers: {
    "x-api-key": string;
  };
  params: {
    swift: string;
  };
}>;

export type GetSwiftCodeResponseType = Partial<{}>;

export const getSwiftCode = (
  payload: AxiosRequestConfig<GetSwiftCodeRequestType>,
): AxiosPromise => {
  const url = `${fetch_swift_code}${payload.params.swift}`;
  return apis.get(url, payload);
};
